module.exports = __webpack_public_path__ + "img/point-1@2x.c7f57d89.jpg";